import React from 'react'
import ReactDOM from 'react-dom/client'
import OurStory from "./pages/OurStory.tsx";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/montserrat/900.css";
import './App.css'
import Academics from "./pages/Academics.tsx";
import ArtsLabs from "./pages/ArtsLabs.tsx";
import OurSchools from "./pages/OurSchools.tsx";
import {Box, createTheme, ThemeProvider} from "@mui/material";
import Admissions from "./pages/Admissions.tsx";
import LetsTalk from "./pages/LetsTalk.tsx";
import ScheduleTour from "./pages/ScheduleTour.tsx";
import backgroundImage from "./assets/background.png";
import LocationIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import './custom.scss';
import Tuition from "./pages/Tuition.tsx";
import Careers from "./pages/Careers.tsx";
import FloatingButtons from "./assets/components/FloatingButtons.tsx";
import TourManagement from "./pages/TourManagement.tsx";
import Privacy from "./pages/Privacy.tsx";
import Terms from "./pages/Terms.tsx";

const router = createBrowserRouter([
    {
        path: "/",
        element: <OurStory/>,
    },
    {
        path: "/privacy-policy",
        element: <Privacy/>,
    },
    {
        path: "/terms-of-service",
        element: <Terms/>,
    },
    {
        path: "/wellington-green",
        element: <OurStory/>,
    },
    {
        path: "/wc",
        element: <OurStory/>,
    },
    {
        path: "/academics",
        element: <Academics/>,
    },
    {
        path: "/arts-labs",
        element: <ArtsLabs/>,
    },
    {
        path: "/admissions",
        element: <Admissions/>,
    },
    {
        path: "/our-schools",
        element: <OurSchools/>,
    },
    {
        path: "/lets-talk",
        element: <LetsTalk/>,
    },
    {
        path: "/schedule-tour",
        element: <ScheduleTour/>,
    },
    {
        path: "/rate-data",
        element: <Tuition/>,
    },
    {
        path: "/careers",
        element: <Careers/>,
    },
    {
        path: "/tour/:token",
        element: <TourManagement/>,
    },
    {
        path: "*",
        element: <OurStory/>,
    },
])

const theme = createTheme({
    typography: {
        fontFamily: [
            'Montserrat',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Box component={"img"} sx={{
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: 0,
                left: 0,
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'cover',
                zIndex: '-2',
            }} src={backgroundImage} alt={"background"}></Box>
            <FloatingButtons items={[
                { name: 'Find School', link: '/our-schools', icon: <LocationIcon /> },
                { name: 'Schedule Tour', link: '/schedule-tour', icon: <CalendarTodayIcon /> },
                { name: 'Contact Us', link: '/lets-talk', icon: <PhoneIcon /> }
            ]} />
            <RouterProvider router={router}/>
        </ThemeProvider>
    </React.StrictMode>,
)
